import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { connect } from 'react-redux';

import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Typography } from '@comparethemarketau/manor-typography';
import { GenericModal } from '@comparethemarketau/manor-modal';
import { Button } from '@comparethemarketau/manor-button';

import { ExcessFilterDropdown } from './excess_filter_dropdown';
import { CoverTypeFilterDropdown } from './cover_type_filter_dropdown';
import { PaymentFrequencyFilterButtonGroup } from './payment_frequency_filter_button_group';
import { updateResultsStateMapping, updateResultsDispatchMapping } from './filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    icon: {
        marginRight: theme.spacing[4],
        fontSize: theme.fontSize.sm
    },
    modal: {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
    },
    modalHeader: {
        display: 'flex',
        flexDirection: 'row',
        padding: {
            left: theme.spacing[24],
            right: theme.spacing[24]
        },
        minHeight: '5.6rem',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.colors.white
    },
    modalHeaderCloseIcon: {
        cursor: 'pointer',
        fontSize: theme.fontSize['4xl'],
        color: theme.colors.grey600
    },
    modalContent: {
        overflow: 'scroll',
        flexGrow: 1,
        backgroundColor: theme.colors.grey100,
        padding: {
            left: theme.spacing[24],
            top: theme.spacing[28],
            right: theme.spacing[24]
        }
    },
    excessFilter: {
        paddingBottom: '2.8rem'
    },
    coverTypeFilter: {
        paddingBottom: '2.8rem'
    },
    paymentFrequencyFilter: {

    },
    modalActions: {
        background: 'white',
        borderTopStyle: 'solid',
        borderWidth: theme.spacing.px,
        borderTopColor: theme.colors.primary200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: {
            top: theme.spacing[16],
            right: theme.spacing[24]
        }
    },
    buttonCancel: {
        marginRight: theme.spacing[32]
    }
}));

const _FiltersRefineModal = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { isShowFiltersUpdateButton, applyUpdateResults, undoStaged, button, className } = props;

    const [visible, setVisible] = useState(false);
    const [paymentChanged, setPaymentChanged] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        setVisible(true);
    };

    const handleClose = () => {
        setVisible(false);
        if (isShowFiltersUpdateButton) {
            undoStaged();
        }
    };

    const handleUpdate = () => {
        setVisible(false);
        applyUpdateResults(
            isShowFiltersUpdateButton
        );
    };

    const handlePaymentChange = (isChanged) => {
        setPaymentChanged(isChanged);
    };

    useEffect(
        () => {
            if (!visible) {
                setPaymentChanged(false);
            }
        }, [visible]
    );

    return (
        <div className={classNames('test-policyFilters-refineModal', className)}>
            {
                button(handleClick)
            }
            <GenericModal
                visible={visible}
                className={classes.modal}
            >
                <div className={classes.modalHeader}>
                    <Typography variant="h2">Refine your filters</Typography>
                    <div onClick={handleClose} role="button" tabIndex="0" className={classes.modalHeaderCloseIcon}>
                        <FontAwesomeIcon icon={faTimes} />
                    </div>
                </div>
                <div className={classes.modalContent}>
                    <div className={classes.excessFilter}><ExcessFilterDropdown useDefaultManorDropdown /></div>
                    <div className={classes.coverTypeFilter}><CoverTypeFilterDropdown useDefaultManorDropdown /></div>
                    <div className={classes.paymentFrequencyFilter}><PaymentFrequencyFilterButtonGroup onChange={handlePaymentChange} /></div>
                </div>
                <div className={classes.modalActions}>
                    <div>
                        <Button
                            variant="tertiary"
                            handleClick={handleClose}
                            trackingLabel={'Cancel button for close the refine filters modal'}
                            className={classes.buttonCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                    <div>
                        <Button
                            variant="primary"
                            handleClick={handleUpdate}
                            trackingLabel={'Update button for the refine filters modal'}
                            disabled={!isShowFiltersUpdateButton && !paymentChanged}
                        >
                            Update results
                        </Button>
                    </div>
                </div>
            </GenericModal>
        </div>
    );
};

_FiltersRefineModal.propTypes = {
    button: PropTypes.func,
    className: PropTypes.string,
    isShowFiltersUpdateButton: PropTypes.bool,
    applyUpdateResults: PropTypes.func,
    undoStaged: PropTypes.func
};

const FiltersRefineModal = connect(updateResultsStateMapping, updateResultsDispatchMapping)(_FiltersRefineModal);

export { FiltersRefineModal };
